import component from '../component';

export default component('MuiButtonBase', {
  defaultProps: {
    disableRipple: true,
  },
});
